// extracted by mini-css-extract-plugin
module.exports = {"empty-contacts":"style_empty-contacts__JmFbZ"};